export default "__VITE_ASSET__09ba8ae9__"